module.exports = __webpack_public_path__ + "static/media/correct.dd76ca28.mp3";